import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { IOption } from 'ng-uikit-pro-standard';
import { Observable } from 'rxjs';
import { FormElementViewModel, IFormElementViewModel, IFormElementViewModelOptions } from '../forms';
import { IFormElementComponent } from '../../view-models/form-element';

@Component({
  selector: 'app-form-select',
  templateUrl: './form-select.component.html',
  styleUrls: ['./form-select.component.scss']
})
export class FormSelectComponent implements OnInit {

  @Input() vm: IFormSelectViewModel;

  @Input() showSimple: boolean = false;
  @Input() isRequired: boolean = true;
  @Input() canEdit: boolean = true; 
  
  @Input() key: string = '';
  @Input() elementId: string = '';
  @Input() description: string = '';
  @Input() helpText: string = '';

  @Input() placeholder: string = 'Pick One';
  
  @Input() optionReadonly: string = '';  
  @Input() optionValue: any = '';

  
  @Input() options: IOption[] = [];
  @Output() selectChanged = new EventEmitter<IFormSelectChangedArg>();

  validationErrors: string[] = [];


  /**
   * 
   */
  constructor() { }

  /**
   * 
   */
  ngOnInit() {

    this.elementId = this.elementId ? this.elementId : this.description ? this.description.replace(' ', '-') : 'select';
    this.key = this.key ? this.key : this.elementId;

    
    this.validate();
  }

  /**
   * 
   * @param display
   * @param value
   */
  modelChanged(vm: IFormSelectViewModel, value: string) {
    // console.log('modelChanged');
    // console.log(value);
    if (this.vm) {
      this.vm.dataSet(value);
    }       
    this.optionValue = value;   
    
    this.validate();

    const option = vm.display.options.find(o => o.value == value);
    this.selectChanged.emit({ sender: this, errors: this.validationErrors, option: option });
  }

  /**
   * 
   */
  private validate() {
    this.validationErrors = this.vm && this.vm.validate ? 
    this.vm.validate({ elementId: this.elementId }) : []   
  }

  /**
   * 
   * @param context 
   * @param field 
   * @param action 
   * @param apiPath 
   * @param options 
   * @returns 
   */
  public static viewModel(context: any, field: string, options: IFormSelectOptions, displayOptions: IDisplaySelectViewModel, elementInstance: number = undefined): IFormSelectViewModel {
    const ret: IFormSelectViewModel = {
      ...FormElementViewModel.create(context, field, options, elementInstance),

      type: options?.type ?? 'text',
      display: displayOptions,
      

      validate: (vm: IFormSelectViewModel) => {
        const errors: string[] = [
          vm.isRequired && (vm.dataGet() ?? "").length == 0 ? 'Required' : undefined,
          (vm.minLength ?? 0) > 0 && (vm.dataGet() ?? "").length < vm.minLength ? `Min length '${vm.minLength}'` : undefined
        ];
        return errors.filter(e => e);
      }
    };
    return ret;
  }  
}

/**
 * 
 */
export interface IDisplaySelectViewModel {
  description?: string;
  helpText?: string;
  options?: IOption[];
  placeholder?: string;
  multiple?: boolean;
}

/**
 * 
 */
export interface IFormSelectChangedArg {
  sender: IFormElementComponent;
  errors: string[];
  option: IOption;
}

/**
 * 
 */
export interface IFormSelectViewModel extends IFormElementViewModel, IFormSelectOptions {
  display: IDisplaySelectViewModel;
}

/**
 * 
 */
export interface IFormSelectOptions extends IFormElementViewModelOptions {
  minLength?: number;

  type?: string;
}
